import { render, staticRenderFns } from "./FooterPopovers.vue?vue&type=template&id=27ab79bd&"
import script from "./FooterPopovers.vue?vue&type=script&lang=js&"
export * from "./FooterPopovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports